import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'

$('.wp-block-gallery').each(function (i) {
  $(this).attr('data-block-gallery', i)
  const items = $(`[data-block-gallery="${i}"]`).find(
    'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
  )
  items.attr('data-fancybox', `block-gallery-${i}`)

  Fancybox.bind(`[data-fancybox="block-gallery-${i}"]`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})
})
